import React, { useState } from 'react';
import css from './JobListingAppliedCard.module.css';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Location } from '../../assets/locationPinNew.svg';
import moment from 'moment';
import WorkersCard from '../WorkersCard/WorkersCard';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { formatMoney } from '../../util/currency';
import { isEmpty } from 'lodash';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import classNames from 'classnames';
import config from '../../config';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import { ReactComponent as JobDtlsIcon } from '../../assets/svg/Icon-feather-eye.svg';
import NamedLink from '../NamedLink/NamedLink';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { createSlug } from '../../util/urlHelpers';
import { languageSelectOptions } from '../../marketplace-custom-config';
const { UUID } = sdkTypes;
const filterConfig = config.custom.filters;
const jobCategoryOptions = findOptionsForSelectFilter('category', filterConfig);
const jobSubCategoryOptions = findOptionsByFilterLabel('Subcategory', filterConfig);
const reducedJobSubCategory = Object.values(jobSubCategoryOptions).reduce(
  (sum, curr) => [...sum, ...curr],
  []
);
function JobListingAppliedCardComponent(props) {
  const {
    userNativeLang,
    history,
    listingTransaction,
    intl,
    listingId,
    getListing,
    fromWorkerDashboardForm,
    listingDetails,
    tab,
  } = props;
  const formattedListingId = new UUID(listingId);
  const listing = getListing(formattedListingId) || listingDetails;

  const [openApplied, setOpenApplied] = useState(false);
  const handleOpenApplied = () => {
    const params = {
      id: listing?.id?.uuid,
    };

    history.push(
      createResourceLocatorString('ApplicantShowingPage', routeConfiguration(), {}, params)
    );
  };
  const { title = '', publicData = {}, price = {} } = (listing && listing.attributes) || {};
  const publishedDate = listing?.attributes?.publicData?.gigPublishedDate;

  const {
    listingAddress = {},
    oneTimeScheduleList = [],
    recurringScheduleList = [],
    scheduleType,
  } = publicData;
  const oneTimeStartTimeHour =
    scheduleType === 'oneTime' &&
    parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.map(
        (m, indx) => m?.startTime?.hours?.value
      )
    );
  const oneTimeStartTimeMin =
    scheduleType === 'oneTime' &&
    parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.map(
        (m, indx) => m?.startTime?.min?.value
      )
    );
  const oneTimeEndTimeHour =
    scheduleType === 'oneTime' &&
    parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.map(
        (m, indx) => m?.endTime?.hours?.value
      )
    );
  const oneTimeEndTimeMin =
    scheduleType === 'oneTime' &&
    parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.map((m, indx) => m?.endTime?.min?.value)
    );
  const oneTimeUnpaidBreak =
    scheduleType === 'oneTime' &&
    parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.map((m, indx) => m?.unpaidBreak?.value)
    );

  const recStartTimeHour =
    scheduleType === 'recurring' &&
    parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.startTime?.hours?.value
      )
    );
  const recStartTimeMin =
    scheduleType === 'recurring' &&
    parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.startTime?.min?.value
      )
    );
  const recEndTimeHour =
    scheduleType === 'recurring' &&
    parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.endTime?.hours?.value
      )
    );
  const recEndTimeMin =
    scheduleType === 'recurring' &&
    parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.endTime?.min?.value
      )
    );
  const recUnpaidBreak =
    scheduleType === 'recurring' &&
    parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.map(
        (m, indx) => m?.unpaidBreak?.value
      )
    );

  const startTimeInMin = oneTimeStartTimeHour * 60 + oneTimeStartTimeMin;
  const endTimeInMin = oneTimeEndTimeHour * 60 + oneTimeEndTimeMin;

  const recstartTimeInMin = recStartTimeHour * 60 + recStartTimeMin;
  const recendTimeInMin = recEndTimeHour * 60 + recEndTimeMin;

  let oneTimeWorkDurationInMIn = endTimeInMin - startTimeInMin - oneTimeUnpaidBreak;
  let recWorkDurationInMIn = recendTimeInMin - recstartTimeInMin - recUnpaidBreak;

  if (oneTimeWorkDurationInMIn < 0) {
    oneTimeWorkDurationInMIn += 24 * 60;
  }
  if (recWorkDurationInMIn < 0) {
    recWorkDurationInMIn += 24 * 60;
  }
  const durationHours = Math.floor(oneTimeWorkDurationInMIn / 60);
  const durationMinutes = oneTimeWorkDurationInMIn % 60;
  const recdurationHours = Math.floor(recWorkDurationInMIn / 60);
  const recdurationMinutes = recWorkDurationInMIn % 60;
  const priceData = (price, intl) => {
    if (price && price.currency === config.currency) {
      const formattedPrice = formatMoney(intl, price);

      return { formattedPrice, priceTitle: formattedPrice };
    } else if (price) {
      return {
        formattedPrice: intl.formatMessage(
          { id: 'ListingCard.unsupportedPrice' },
          { currency: price.currency }
        ),
        priceTitle: intl.formatMessage(
          { id: 'ListingCard.unsupportedPriceTitle' },
          { currency: price.currency }
        ),
      };
    }
    return {};
  };
  const formatDate = date => {
    return userNativeLang === languageSelectOptions.fr.value
      ? moment(date).format('Do MMM y')
      : moment(date).format('Do MMM, y');
  };
  const { formattedPrice: myPrice } = priceData(listing?.attributes?.price, intl);
  return (
    <div className={css.mainCardDiv}>
      <div
        className={classNames(css.JobListingCardWrapper, {
          [css.bestMatchesDiv]: !fromWorkerDashboardForm,
        })}
      >
        {fromWorkerDashboardForm ? (
          <>
            <div className={css.NextShiftDiv}>
              {tab === 'currentShifts' ? (
                <FormattedMessage id="JobListingAppliedCard.currentShift" />
              ) : tab === 'upcomingShifts' ? (
                <FormattedMessage id="JobListingAppliedCard.NextShift" />
              ) : (
                <FormattedMessage id="JobListingAppliedCard.pastShift" />
              )}

              {scheduleType === 'recurring' ? (
                <span className={css.nextDate}>
                  {' '}
                  {recurringScheduleList?.map(m => formatDate(m.startDate.date))}
                </span>
              ) : (
                <span className={css.nextDate}>
                  {oneTimeScheduleList?.map(m => formatDate(m.startDate.date))}
                </span>
              )}
            </div>
          </>
        ) : (
          <>
            <div className={css.IdDiv}>
              <FormattedMessage id="SearchPage.gigId" />{' '}
              <span>
                {listing?.attributes?.publicData?.gigId
                  ? listing?.attributes?.publicData?.gigId
                  : 'G - 123456'}
              </span>
            </div>
          </>
        )}

        {fromWorkerDashboardForm ? (
          <>
            <div className={css.titletoend}>
              <div className={css.heading}>
                <span className={css.headingName}>{title}</span>
              </div>
              <div className={css.JobDetailsSubHeadingDiv}>
                <span className={css.category}>
                  {jobCategoryOptions
                    .filter(f =>
                      listing?.attributes?.publicData?.jobCategories.find(
                        m => m?.category === f?.value
                      )
                    )
                    ?.map(m => m?.label[userNativeLang])}
                </span>
                -
                <span className={css.subcategory}>
                  {
                    reducedJobSubCategory.find(
                      m =>
                        listing?.attributes?.publicData?.jobCategories[0]?.subCategory === m.value
                    )?.label[userNativeLang]
                  }
                </span>
              </div>
              <div className={css.locationDiv}>
                <div className={css.locate}>
                  <Location className={css.location} />{' '}
                </div>
                <span className={css.address}>
                  {(listingAddress && listingAddress.address) || ''}
                </span>
              </div>

              {myPrice ? (
                <span className={css.PriceTag}>
                  <FormattedMessage id="SearchPage.Priceperhour" /> &nbsp;
                  <span>{myPrice}</span>
                </span>
              ) : null}
              <div className={css.hourDiv}>
                {scheduleType === 'recurring' ? (
                  <span>
                    {listing?.attributes?.publicData?.recurringScheduleList?.map((r, indx) => {
                      const recurringDays =
                        typeof r.recurringDays === 'string'
                          ? r.recurringDays.split(',')
                          : r.recurringDays.map(m => m);
                      return (
                        <>
                          {r.startDate.date !== null ? (
                            <>
                              {indx > 0 &&
                                listing?.attributes?.publicData?.oneTimeScheduleList[indx]?.startDate
                                  ?.date !== null ? (
                                <>
                                  <hr className={css.hrColor} />
                                  <div className={css.recWorkperDay}>
                                    {recdurationHours ? (
                                      <FormattedMessage id="SearchPage.workPerDay" />
                                    ) : null}
                                    &nbsp;
                                    <b>
                                      {' '}
                                      {recdurationHours ? (
                                        <>
                                          {recdurationHours}
                                          {` `}
                                          <FormattedMessage id="ListingCardCustom.hours" />
                                        </>
                                      ) : null}
                                      {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                        ? ` ${recdurationMinutes} minutes`
                                        : null}
                                    </b>{' '}
                                    {r?.unpaidBreak?.value &&
                                      parseInt(r?.unpaidBreak?.value) > 0 ? (
                                      <>
                                        -&nbsp;
                                        <FormattedMessage id="SearchPage.unpaidBreak" />
                                        &nbsp;
                                        <b>{r?.unpaidBreak?.value} Minutes</b>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className={css.workPerDay}>
                                    <FormattedMessage id="SearchPage.recurringDays" />
                                    &nbsp;
                                    {recurringDays[0] === '' ? (
                                      <>
                                        <b>
                                          <FormattedMessage id="SearchPage.Daily" />
                                        </b>
                                      </>
                                    ) : (
                                      recurringDays.map((m, indx) =>
                                        indx > 0 ? (
                                          <div key={indx}>
                                            <b>, {m}</b>
                                          </div>
                                        ) : (
                                          <b key={indx}>{m}</b>
                                        )
                                      )
                                    )}
                                    &nbsp;- <FormattedMessage id="SearchPage.Days" /> &nbsp;
                                    <b> {formatDate(r?.startDate?.date)}</b>{' '}
                                    <FormattedMessage id="SearchPage.to" /> &nbsp;
                                    <b> {formatDate(r?.endDate?.date)}</b> &nbsp;
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={css.recWorkperDay}>
                                    {recdurationHours ? (
                                      <FormattedMessage id="SearchPage.workPerDay" />
                                    ) : null}
                                    &nbsp;
                                    <b>
                                      {' '}
                                      {recdurationHours ? (
                                        <>
                                          {recdurationHours}
                                          {` `}
                                          <FormattedMessage id="ListingCardCustom.hours" />
                                        </>
                                      ) : null}
                                      {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                        ? ` ${recdurationMinutes} minutes`
                                        : null}
                                    </b>{' '}
                                    &nbsp;
                                    {r?.unpaidBreak?.value &&
                                      parseInt(r?.unpaidBreak?.value) > 0 ? (
                                      <>
                                        -&nbsp;
                                        <FormattedMessage id="SearchPage.unpaidBreak" />
                                        &nbsp;
                                        <b>{r?.unpaidBreak?.value} Minutes</b>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className={css.workPerDay}>
                                    <FormattedMessage id="SearchPage.recurringDays" />
                                    &nbsp;
                                    {recurringDays[0] === '' ? (
                                      <>
                                        <b>
                                          <FormattedMessage id="SearchPage.Daily" />
                                        </b>
                                      </>
                                    ) : (
                                      recurringDays.map((m, indx) =>
                                        indx > 0 ? (
                                          <>
                                            &nbsp; <b>, {m}</b>
                                          </>
                                        ) : (
                                          <b>{m}</b>
                                        )
                                      )
                                    )}
                                    &nbsp;- <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;{' '}
                                    <b> {formatDate(r?.startDate?.date)}</b> &nbsp;
                                    <FormattedMessage id="SearchPage.to" /> &nbsp;
                                    <b> {formatDate(r?.endDate?.date)}</b>
                                  </div>
                                  <div className={css.scheduleDiv}>
                                    <div className={css.workerCountDiv}>
                                      {' '}
                                      <span>
                                        <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                      </span>
                                      <span>
                                        {r?.startTime?.hours.value} : {r?.startTime?.min.value}{' '}
                                        &nbsp;- &nbsp;
                                      </span>{' '}
                                    </div>
                                    <div className={css.workerCountDiv}>
                                      {' '}
                                      <span>
                                        <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                      </span>
                                      <span>
                                        {r?.endTime?.hours.value} : {r?.endTime?.min.value}
                                      </span>{' '}
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          ) : null}
                        </>
                      );
                    })}
                  </span>
                ) : (
                  <span>
                    {listing?.attributes?.publicData?.oneTimeScheduleList.map((m, indx) => {
                      return (
                        <>
                          {indx > 0 ? (
                            <>
                              <hr className={css.hrColor} />
                              <div className={css.workPerDay}>
                                {durationHours ? (
                                  <FormattedMessage id="SearchPage.workPerDay" />
                                ) : null}
                                &nbsp;
                                <b>
                                  {durationHours ? (
                                    <>
                                      {durationHours}
                                      {` `}
                                      <FormattedMessage id="ListingCardCustom.hours" />
                                    </>
                                  ) : null}
                                  {durationMinutes !== 0 && typeof durationMinutes !== NaN
                                    ? ` ${durationMinutes} minutes`
                                    : null}
                                </b>{' '}
                                &nbsp;
                                {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                                  <>
                                    {` - `}
                                    <FormattedMessage id="SearchPage.unpaidBreak" />
                                    &nbsp;
                                    <b>{m?.unpaidBreak?.value} Minutes</b>
                                  </>
                                ) : null}
                                {m?.startDate?.date ? (
                                  <>
                                    {Object.values(m?.startDate?.date).length === 0 ? null : ` - `}
                                    <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;{' '}
                                    <b> {formatDate(m?.startDate?.date)}</b> &nbsp;
                                  </>
                                ) : null}
                              </div>
                              <div className={css.scheduleDiv}>
                                <div className={css.workerCountDiv}>
                                  {' '}
                                  <span>
                                    <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                  </span>
                                  <span>
                                    {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;-
                                    &nbsp;
                                  </span>{' '}
                                </div>
                                <div className={css.workerCountDiv}>
                                  {' '}
                                  <span>
                                    <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                  </span>
                                  <span>
                                    {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                                  </span>{' '}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className={css.workPerDay}>
                              {durationHours ? (
                                <FormattedMessage id="SearchPage.workPerDay" />
                              ) : null}
                              &nbsp;
                              <b>
                                {durationHours ? (
                                  <>
                                    {durationHours}
                                    {` `}
                                    <FormattedMessage id="ListingCardCustom.hours" />
                                  </>
                                ) : null}
                                {durationMinutes !== 0 && typeof durationMinutes !== NaN
                                  ? ` ${durationMinutes} minutes`
                                  : null}
                              </b>{' '}
                              {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                                <>
                                  {` - `}
                                  <FormattedMessage id="SearchPage.unpaidBreak" />
                                  &nbsp;
                                  <b>{m?.unpaidBreak?.value} Minutes</b>
                                </>
                              ) : null}
                              {m?.startDate?.date ? (
                                <>
                                  {Object.values(m?.startDate?.date).length === 0 ? null : ` - `}
                                  <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;{' '}
                                  <b> {formatDate(m?.startDate?.date)}</b>&nbsp;
                                </>
                              ) : null}
                              <div className={css.scheduleDiv}>
                                <div className={css.workerCountDiv}>
                                  {' '}
                                  <span>
                                    <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                  </span>
                                  <span>
                                    {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;-
                                    &nbsp;
                                  </span>{' '}
                                </div>
                                <div className={css.workerCountDiv}>
                                  {' '}
                                  <span>
                                    <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                  </span>
                                  <span>
                                    {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                                  </span>{' '}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                  </span>
                )}
              </div>
              {listing?.attributes?.publicData?.workerYouNeed ? (
                <p className={css.TotalWorkerDiv}>
                  <FormattedMessage id="SearchPage.totalProposedWorker" />{' '}
                  <b>{listing?.attributes?.publicData?.workerYouNeed}</b>
                </p>
              ) : null}
              <span className={css.hDivider} />
              {!fromWorkerDashboardForm ? (
                <>
                  {' '}
                  <div className={css.tabContentContainer}>
                    {listingTransaction.map(({ customer, transaction }, i) => {
                      const txId = transaction && transaction.id && transaction.id.uuid;
                      return (
                        <WorkersCard
                          workerDetails={customer}
                          workerProfileImages={customer.profileImage}
                          key={txId}
                          txId={txId}
                          listingId={listingId}
                          userNativeLang={userNativeLang}
                          history={history}
                          from={'ListingApplied'}
                        />
                      );
                    })}
                  </div>
                </>
              ) : null}
              <div className={css.IdDivforDashboard}>
                <div>
                  <FormattedMessage id="SearchPage.gigId" />{' '}
                  <span>
                    {listing?.attributes?.publicData?.gigId
                      ? listing?.attributes?.publicData?.gigId
                      : 'G - 123456'}
                  </span>
                </div>
                {listing?.attributes?.title !== null ? (
                  <span className={css.ListingCardView}>
                    <NamedLink
                      name="ListingPage"
                      params={{
                        id: listing?.id?.uuid,
                        slug: createSlug(listing?.attributes?.title || ''),
                      }}
                    >
                      <JobDtlsIcon />
                      <FormattedMessage id="View" />
                    </NamedLink>
                  </span>
                ) : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={css.heading}>
              <span className={css.headingName}>{title}</span>
            </div>
            <div className={css.JobDetailsSubHeadingDiv}>
              <span className={css.category}>
                {jobCategoryOptions
                  .filter(f =>
                    listing?.attributes?.publicData?.jobCategories.find(m => m.category === f.value)
                  )
                  ?.map(m => m.label[userNativeLang])}
              </span>
              -
              <span className={css.subcategory}>
                {
                  reducedJobSubCategory.find(
                    m => listing?.attributes?.publicData?.jobCategories[0]?.subCategory === m.value
                  )?.label[userNativeLang]
                }
              </span>
            </div>
            <div className={css.locationDiv}>
              <div className={css.locateIcon}>
                <Location className={css.location} />{' '}
              </div>
              <span>{(listingAddress && listingAddress.address) || ''}</span>
            </div>
            {myPrice ? (
              <span className={css.PriceTag}>
                <FormattedMessage id="SearchPage.Priceperhour" /> &nbsp;
                <span>{myPrice}</span>
              </span>
            ) : null}

            <div className={css.hourDiv}>
              {scheduleType === 'recurring' ? (
                <span>
                  {listing?.attributes?.publicData?.recurringScheduleList?.map((r, indx) => {
                    const recurringDays =
                      typeof r.recurringDays === 'string'
                        ? r.recurringDays.split(',')
                        : r.recurringDays.map(m => m);
                    return (
                      <>
                        {r.startDate.date !== null ? (
                          <>
                            {indx > 0 &&
                              listing?.attributes?.publicData?.oneTimeScheduleList[indx]?.startDate
                                ?.date !== null ? (
                              <>
                                <hr className={css.hrColor} />
                                <div className={css.recWorkperDay}>
                                  {recdurationHours ? (
                                    <FormattedMessage id="SearchPage.workPerDay" />
                                  ) : null}
                                  &nbsp;
                                  <b>
                                    {' '}
                                    {recdurationHours ? (
                                      <>
                                        {recdurationHours}
                                        {` `}
                                        <FormattedMessage id="ListingCardCustom.hours" />
                                      </>
                                    ) : null}
                                    {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                      ? ` ${recdurationMinutes} minutes`
                                      : null}
                                  </b>{' '}
                                  &nbsp;
                                  {r?.unpaidBreak?.value && parseInt(r?.unpaidBreak?.value) > 0 ? (
                                    <>
                                      -&nbsp;
                                      <FormattedMessage id="SearchPage.unpaidBreak" />
                                      &nbsp;
                                      <b>{r?.unpaidBreak?.value} Minutes</b>
                                    </>
                                  ) : null}
                                </div>
                                <div className={css.workPerDay}>
                                  <FormattedMessage id="SearchPage.recurringDays" />
                                  &nbsp;
                                  {recurringDays[0] === '' ? (
                                    <>
                                      <b>
                                        <FormattedMessage id="SearchPage.Daily" />
                                      </b>{' '}
                                      &nbsp;
                                    </>
                                  ) : (
                                    recurringDays.map((m, indx) =>
                                      indx > 0 ? (
                                        <div key={indx}>
                                          <b>, {m}</b>
                                        </div>
                                      ) : (
                                        <b key={indx}>{m}</b>
                                      )
                                    )
                                  )}
                                  &nbsp;- <FormattedMessage id="SearchPage.Days" /> &nbsp;
                                  <b> {formatDate(r?.startDate?.date)}</b> &nbsp;
                                  <FormattedMessage id="SearchPage.to" /> &nbsp;
                                  <b> {formatDate(r?.endDate?.date)}</b> &nbsp;
                                </div>
                              </>
                            ) : (
                              <>
                                <div className={css.recWorkperDay}>
                                  {recdurationHours ? (
                                    <FormattedMessage id="SearchPage.workPerDay" />
                                  ) : null}
                                  &nbsp;
                                  <b>
                                    {' '}
                                    {recdurationHours ? (
                                      <>
                                        {recdurationHours}
                                        {` `}
                                        <FormattedMessage id="ListingCardCustom.hours" />
                                      </>
                                    ) : null}
                                    {recdurationMinutes !== 0 && typeof recdurationMinutes !== NaN
                                      ? ` ${recdurationMinutes} minutes`
                                      : null}
                                  </b>{' '}
                                  {r?.unpaidBreak?.value && parseInt(r?.unpaidBreak?.value) > 0 ? (
                                    <>
                                      -&nbsp;
                                      <FormattedMessage id="SearchPage.unpaidBreak" />
                                      &nbsp;
                                      <b>{r?.unpaidBreak?.value} Minutes</b>
                                    </>
                                  ) : null}
                                </div>
                                <div className={css.workPerDay}>
                                  <FormattedMessage id="SearchPage.recurringDays" />
                                  &nbsp;
                                  {recurringDays[0] === '' ? (
                                    <>
                                      <b>
                                        <FormattedMessage id="SearchPage.Daily" />
                                      </b>
                                    </>
                                  ) : (
                                    recurringDays.map((m, indx) =>
                                      indx > 0 ? (
                                        <>
                                          <b>, {m}</b>
                                        </>
                                      ) : (
                                        <b>{m}</b>
                                      )
                                    )
                                  )}
                                  &nbsp;- <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;{' '}
                                  <b> {formatDate(r?.startDate?.date)}</b> &nbsp;
                                  <FormattedMessage id="SearchPage.to" /> &nbsp; &nbsp;{' '}
                                  <b> {formatDate(r?.endDate?.date)}</b> &nbsp;
                                </div>
                                <div className={css.scheduleDiv}>
                                  <div className={css.workerCountDiv}>
                                    {' '}
                                    <span>
                                      <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                    </span>
                                    <span>
                                      {r?.startTime?.hours.value} : {r?.startTime?.min.value}{' '}
                                      &nbsp;- &nbsp;
                                    </span>{' '}
                                  </div>
                                  <div className={css.workerCountDiv}>
                                    {' '}
                                    <span>
                                      <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                    </span>
                                    <span>
                                      {r?.endTime?.hours.value} : {r?.endTime?.min.value}
                                    </span>{' '}
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ) : null}
                      </>
                    );
                  })}
                </span>
              ) : (
                <span>
                  {listing?.attributes?.publicData?.oneTimeScheduleList.map((m, indx) => {
                    return (
                      <>
                        {indx > 0 ? (
                          <>
                            <hr className={css.hrColor} />
                            <div className={css.workPerDay}>
                              {durationHours ? (
                                <FormattedMessage id="SearchPage.workPerDay" />
                              ) : null}
                              &nbsp;
                              <b>
                                {durationHours ? (
                                  <>
                                    {durationHours}
                                    {` `}
                                    <FormattedMessage id="ListingCardCustom.hours" />
                                  </>
                                ) : null}
                                {durationMinutes !== 0 && typeof durationMinutes !== NaN
                                  ? ` ${durationMinutes} minutes`
                                  : null}
                              </b>{' '}
                              {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                                <>
                                  {` - `}
                                  <FormattedMessage id="SearchPage.unpaidBreak" />
                                  &nbsp;
                                  <b>{m?.unpaidBreak?.value} Minutes</b>
                                </>
                              ) : null}
                              {m?.startDate?.date ? (
                                <>
                                  {Object.values(m?.startDate?.date).length === 0 ? null : ` - `}
                                  <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;
                                  <b> {formatDate(m?.startDate?.date)}</b> &nbsp;
                                </>
                              ) : null}
                            </div>
                            <div className={css.scheduleDiv}>
                              <div className={css.workerCountDiv}>
                                {' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                </span>
                                <span>
                                  {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;-
                                  &nbsp;
                                </span>{' '}
                              </div>
                              <div className={css.workerCountDiv}>
                                {' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                </span>
                                <span>
                                  {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                                </span>{' '}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className={css.workPerDay}>
                            {durationHours ? <FormattedMessage id="SearchPage.workPerDay" /> : null}
                            &nbsp;
                            <b>
                              {durationHours ? (
                                <>
                                  {durationHours}
                                  {` `}
                                  <FormattedMessage id="ListingCardCustom.hours" />
                                </>
                              ) : null}
                              {durationMinutes !== 0 && typeof durationMinutes !== NaN
                                ? ` ${durationMinutes} minutes`
                                : null}
                            </b>{' '}
                            {m?.unpaidBreak?.value && parseInt(m?.unpaidBreak?.value) > 0 ? (
                              <>
                                {` - `}
                                <FormattedMessage id="SearchPage.unpaidBreak" />
                                &nbsp;
                                <b>{m?.unpaidBreak?.value} Minutes</b>
                              </>
                            ) : null}
                            {m?.startDate?.date ? (
                              <>
                                {Object.values(m?.startDate?.date).length === 0 ? null : ` - `}
                                <FormattedMessage id="SearchPage.Days" /> &nbsp; &nbsp;{' '}
                                <b> {formatDate(m?.startDate?.date)}</b> &nbsp;
                              </>
                            ) : null}
                            <div className={css.scheduleDiv}>
                              <div className={css.workerCountDiv}>
                                {' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                                </span>
                                <span>
                                  {m?.startTime?.hours.value} : {m?.startTime?.min.value} &nbsp;-
                                  &nbsp;
                                </span>{' '}
                              </div>
                              <div className={css.workerCountDiv}>
                                {' '}
                                <span>
                                  <FormattedMessage id="FieldDateTimeInput.endTime" /> :
                                </span>
                                <span>
                                  {m?.endTime?.hours.value} : {m?.endTime?.min.value}
                                </span>{' '}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
                </span>
              )}
            </div>

            {listing?.attributes?.publicData?.workerYouNeed ? (
              <p className={css.TotalWorkerDiv}>
                <FormattedMessage id="SearchPage.totalProposedWorker" /> {`  `}
                <b>{listing?.attributes?.publicData?.workerYouNeed}</b>
              </p>
            ) : null}
            <span className={css.hDivider} />
            {listingTransaction.length >= 0 ? (
              <span
                className={css.headingName}
                onClick={() => {
                  const params = {
                    id: listing ? listing?.id?.uuid : null,
                  };
                  history.push(
                    createResourceLocatorString(
                      'ApplicantShowingPage',
                      routeConfiguration(),
                      params
                    )
                  );
                }}
              >
                <FormattedMessage id="JobListingAppliedCard.showAll" />
              </span>
            ) :
              null}
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    getListing,
  };
};

const JobListingAppliedCard = compose(connect(mapStateToProps))(JobListingAppliedCardComponent);

export default JobListingAppliedCard;
